import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cash-flow-calculator',
  component: () => import('../../routes/CashFlowCalculator.svelte'),
  card: {
    id: 'cash-flow-calculator',
    title: 'Cash Flow Calculator',
    description: 'Analyze cash flow from operating, investing, and financing activities with the indirect method.',
    icon: 'payments',
    iconBgClass: 'bg-teal-50',
    iconTextClass: 'text-teal-600',
    href: '/cash-flow-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Cash Flow Calculator – Indirect Method Statement Analysis',
    description: 'Free cash flow calculator using the indirect method. Analyze operating, investing, and financing cash flows to determine net change in cash and free cash flow.',
  },
};

export default meta;
